module.exports = __webpack_public_path__ + "static/davids-8e77808ec04aea90d816ef83268f395e.png";